export default {
    inspectors: [],
    inspections: [],
    loading: true,
    inspectionLogs: [],
    inspectionFormConfigId: null,
}
